import SceneContainer from "./Scene";

export default SceneContainer;
